import { createThunkEffect, createAction } from "../../utilities/ActionUtility";
import * as OrderEffect from "./OrderEffect";

export const REQUEST_USER_ORDERS = "OrdersEffect.REQUEST_USER_ORDERS";
export const REQUEST_USER_ORDERS_FINISHED = "OrdersEffect.REQUEST_USER_ORDERS_FINISHED";

export function requestUserOrders(user) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_ORDERS, OrderEffect.requestUserOrders, user);
    };
}

export const REQUEST_ALL_ORDERS = "OrdersEffect.REQUEST_ALL_ORDERS";
export const REQUEST_ALL_ORDERS_FINISHED = "OrdersEffect.REQUEST_ALL_ORDERS_FINISHED";

export function requestAllOrders() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_ORDERS, OrderEffect.requestAllOrders);
    };
}

export const REQUEST_ALL_ORDERS_BASIC = "OrdersEffect.REQUEST_ALL_ORDERS_BASIC";
export const REQUEST_ALL_ORDERS_BASIC_FINISHED = "OrdersEffect.REQUEST_ALL_ORDERS_BASIC_FINISHED";

export function requestAllOrdersBasic() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_ORDERS_BASIC, OrderEffect.requestAllOrdersBasic);
    };
}

export const REQUEST_SPECIFIC_ORDER = "OrdersEffect.REQUEST_SPECIFIC_ORDER";
export const REQUEST_SPECIFIC_ORDER_FINISHED = "OrdersEffect.REQUEST_SPECIFIC_ORDER_FINISHED";

export function requestSpecificOrder(user, orderId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SPECIFIC_ORDER, OrderEffect.requestSpecificOrder, user, orderId);
    };
}

export const UPDATE_USER_ORDER = "OrdersEffect.UPDATE_USER_ORDER";
export const UPDATE_USER_ORDER_FINISHED = "OrdersEffect.UPDATE_USER_ORDER_FINISHED";

export function updateUserOrder(userId, orderId, params) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, UPDATE_USER_ORDER, OrderEffect.updateUserOrder, userId, orderId, params);
    };
}

export const CREATE_EMPTY_ORDER = "OrdersEffect.CREATE_EMPTY_ORDER";
export const CREATE_EMPTY_ORDER_FINISHED = "OrdersEffect.CREATE_EMPTY_ORDER_FINISHED";

export function createEmptyOrder(userId, params) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, CREATE_EMPTY_ORDER, OrderEffect.createEmptyOrder, userId, params);
    };
}

export const DELETE_ORDER_ID_FROM_STATE = "DELETE_ORDER_ID_FROM_STATE";

export function deleteOrderIdFromState() {
    return async(dispatch) => {
        await dispatch(createAction(DELETE_ORDER_ID_FROM_STATE));
    };
}

export const ACCEPT_TERMS_CONDITIONS = "OrdersEffect.ACCEPT_TERMS_CONDITIONS";
export const ACCEPT_TERMS_CONDITIONS_FINISHED = "OrdersEffect.ACCEPT_TERMS_CONDITIONS_FINISHED";

export function acceptTermsConditions(userId, orderId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, ACCEPT_TERMS_CONDITIONS, OrderEffect.acceptTermsConditions, userId, orderId);
    };
}
